/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";

import { SF_COMMUNICATION } from "./constants";
import { useAppProviderContext } from "./context/appProvider";
import { getMutationObserver } from "./helpers";
import { useIBStartupData } from "./hooks";
import GamblingBlock from "./pages/gamblingBlock/GamblingBlock";

function App() {
  const { dispatch } = useAppProviderContext();
  const { onStart, setIBHeight } = useIBStartupData(dispatch);

  const [iFrameHeight, setIFrameHeight] = useState<number>(
    SF_COMMUNICATION.IFRAME_HEIGHT
  );

  const initializeCommunication = () => {
    const observer = getMutationObserver(setIFrameHeight);
    return observer;
  };

  useEffect(() => {
    setIBHeight(iFrameHeight);
  }, [iFrameHeight]);

  useEffect(() => {
    const observer = initializeCommunication();
    onStart();

    return () => {
      observer?.disconnect();
    };
  }, []);

  return <GamblingBlock />;
}

export default App;
